export default {

  "meta-title": "TARISLAND",
  "meta-description": "Tarisland is a classic MMORPG on PC and mobile devices, featuring raids, diverse classes, crossplay and a vast world for exploration. Embark on your epic adventure together.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Tarisland Official Website",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Tarisland Official Website",
  "meta-og-title": "Tarisland Official Website",
  "meta-og-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Tarisland Official Website",
  "meta-twitter-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",

  "email_illegal": "Incorrect Email address. Please check and resubmit it.",
  "horizon_tip": "For a better experience, please rotate your device.",

  'downloadPc': "Please download on PC",

  "area": "Zone",
  "select-area": "Veuillez choisir une zone",
  "server": "Serveur",
  "select-server": "Veuillez choisir un serveur",
  "character-name": "Nom de personnage",
  "select-character": "Veuillez choisir un personnage",
  "please-select": "Veuillez choisir",
  "not-found-role": "Infos du personnage non trouvées",
  'loading': '加載中....',
  'pls_input_info': '請輸入您的登錄信息。',
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Devenez mon partenaire dans Tarisland !\nCliquez/touchez :",
  "copy_clipboard-text2": "(lien exclusif)\nEn cas de problème avec le lien, vous pouvez saisir le code d'invitation :",
  "friends-completed": "amis ayant terminé",
  "no-friends-completed": "Aucun ami(e) ayant terminé",
  "pop_invitedlist_s": "TERMINÉE(S)",
  "pop_invitedlist_f": "NON TERMINÉE(S)",
  "gift3": "Pack de croissance de S1",
  "gift5": "Esprit du loup de givre (Permanent)",
  "gift6": "Esprit du loup de givre (1 jour)",
  "gift1": "Carte-cadeau de 100 $",
  "gift2": "Carte-cadeau de 50 $",
  "gift4": "Esprit du tigre pyro (Permanent)",

  "invite_link_upper_limit": "Désolés, ce lien ou code d'invitation a atteint sa limite d'utilisations.",
  "invite_link_disabled": "Lien d'invitation non valide ou code expiré. Renseignez-vous auprès de l'hôte.",
  "enter_your_invitation_code": "Saisissez votre code d'invitation",
  "act_not_start": "L'événement n'a pas commencé.",
  "act_finished": "L'événement a pris fin.",
  "download_pc": "Veuillez télécharger sur PC",
  "email_error": "E-mail non valide. Veuillez le vérifier.",
  "loadding": "Chargement...",
  "check_my_raffle_history": "Voir mon historique de tirage au sort",
  "no_raffle_history": "Aucun historique de tirage au sort",
  "system-error": "Erreur système",
  "cant-invite-self": "Vous ne pouvez pas vous inviter vous-même",
}